import { render, staticRenderFns } from "./FeatureSubs.vue?vue&type=template&id=92bf75e0&scoped=true&"
import script from "./FeatureSubs.vue?vue&type=script&lang=js&"
export * from "./FeatureSubs.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSubs.vue?vue&type=style&index=0&id=92bf75e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bf75e0",
  null
  
)

export default component.exports